export const formLimits = {
  name: 80,
  email: 70,
  phone: 19,
  subject: 50,
  serviceType: 80,
  preferredContactMethod: 30,
  otherServiceDescription: 250,
  message: 1500,
} as const

export type FormFieldErrors = Record<string, string>

export function describedBy(...ids: Array<string | false | null | undefined>) {
  return ids.filter(Boolean).join(' ') || undefined
}
